<template>
    <button :class="classes" @click="$emit('click', $event)">
        <span>{{`${score > 0 ? 'Unsave' : 'Save'} Item`}}</span>
    </button>
</template>

<script>
    export default {
        props: {
            score: Number|String,
            animating: Boolean,
            classes: String|Array|Object,
        },
    }
</script>

<style lang="scss" scoped>
    button {
        transition: opacity ease-in-out 0.2s;
    }
    .loading {
        opacity: 0.5;
    }
</style>
